export const ticketActionTypes = {
  FETCH_TICKETS_START: 'FETCH_TICKETS_START',
  FETCH_TICKETS_SUCCESS: 'FETCH_TICKETS_SUCCESS',
  FETCH_TICKETS_FAIL: 'FETCH_TICKETS_FAIL',
  SET_TICKETS: 'SET_TICKETS',
  SET_VIEWED_TICKETS: 'SET_VIEWED_TICKETS',
};